import { Button, Dialog, Grid, Typography, useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import React from 'react';
import { useEffect } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import { useTheme } from '@emotion/react';
import {
  forwardBuyersOfferToOtherBuyers,
  postApiCall,
  Moxoseparationinlisting,
} from 'api/apiService';
import Swal from 'sweetalert2';
import { BUYER_AUTO_OFFER } from 'constant/app.config';
import Loading from 'assets/images/loading.png';

export default function ShareOfferWithMarketPlace(props) {
  const {
    shareMarketPlace,
    setShareMarketPlace,
    getListInfo,
    address,
    offerUniqueId,
    selectedrowbuyername,
    buyerOfferPrice,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [shareMarketPlaceLoader, setShareMarketPlaceLoader] =
    React.useState(false);
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const shareMarketPlaceFunc = (selectedrowbuyername, buyerOfferPrice) => {
    setShareMarketPlaceLoader(true);
    let input = {
      offerUniqueId: offerUniqueId,
      isMarket: 1,
      buyerArr: null,
    };

    forwardBuyersOfferToOtherBuyers(input)
      .then((res) => {
        if (res?.status == 1) {
          getListInfo();
          setShareMarketPlaceLoader(false);
          setShareMarketPlace(false);
          moxosepforwardOfferToBuyerFunc(res);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            html: `<span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${selectedrowbuyername}</span>'s offer of 
              <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${buyerOfferPrice}</span> 
              has been shared with the Marketplace and the vendor.`,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setShareMarketPlaceLoader(false);
          setShareMarketPlace(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setShareMarketPlaceLoader(false));
  };

  const moxosepforwardOfferToBuyerFunc = (res) => {
    if (isNotEmptyArray(res?.dataForBuyerOfferSharingAck))
      Moxoseparationinlisting(
        'dataForBuyerOfferSharingAck',
        res?.dataForBuyerOfferSharingAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerOffersAck))
      Moxoseparationinlisting(
        'dataForBuyerOffersAck',
        res?.dataForBuyerOffersAck
      ); //2
  };

  useEffect(() => {
    if (shareMarketPlaceLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [shareMarketPlaceLoader]);

  return (
    <Dialog
      open={shareMarketPlace}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {'   '}
            {address}
            &nbsp;
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'12px 0px 15px 0'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Share Offer with Marketplace
          </Typography>
        </Grid>
        <Grid item textAlign={'left'} paddingTop={'10px'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
            }}
            whiteSpace={'wrap'}
          >
            Share{' '}
            <Typography component="span">
              <b
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  color: '#666666',
                  fontSize: matchessm ? '12px' : '16px',
                }}
              >
                {selectedrowbuyername}
              </b>
            </Typography>
            's offer of{' '}
            <Typography component="span">
              <b
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                {buyerOfferPrice}
              </b>
            </Typography>{' '}
            on the Marketplace. The vendor will also receive this offer update.
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          marginTop={matchessm ? '15px' : 5}
        >
          <Grid item>
            <Button
              disabled={shareMarketPlaceLoader}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => setShareMarketPlace(false)}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
          >
            <Button
              disabled={shareMarketPlaceLoader}
              variant="outlined"
              onClick={() =>
                shareMarketPlaceFunc(selectedrowbuyername, buyerOfferPrice)
              }
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'none',
              }}
            >
              Share
            </Button>
            {shareMarketPlaceLoader && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}
